import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/Master";
import getToken from "app/api/getToken";
import { IMaster } from "app/api/types/Masters";

export const ADD_MASTER_REQUEST = "ADD_MASTER_REQUEST";
export const ADD_MASTER_SUCCESS = "ADD_MASTER_SUCCESS";
export const ADD_MASTER_FAIL = "ADD_MASTER_FAIL";

export const addMaster = (data: IMaster) => (dispatch: any): any => {
  dispatch({ type: ADD_MASTER_REQUEST });

  const token = getToken();

  return api
    .addMaster(token, data)
    .then((response: AxiosResponse) => {
      const master: IMaster = get(response, "data", {});
      dispatch({ type: ADD_MASTER_SUCCESS, payload: master });

      return master;
    })
    .catch(err => {
      dispatch({
        type: ADD_MASTER_FAIL,
        payload: get(err, "response.data.errors", {})
      });
      throw get(err, "response.data.errors", {});
    });
};
